import { API_URL } from 'config';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../context/LanguageContext';

export const Sidebar = ({ activeTab, setActiveTab, hasKey, triggerToast, isOpen, onClose }) => {
  const { language, setLanguage, t } = useLanguage();
  const navigate = useNavigate();

  const handleTabClick = (tabId) => {
    if (tabId === 'modules' && !hasKey) {
      triggerToast(t('dashboard.linkKeyFirst'), 'warning');
      return;
    }
    setActiveTab(tabId);
  };

  const handleDownload = () => {
    window.open(`${API_URL}/download/`, '_blank');
  };

  const handleLogout = async () => {
    try {
      await fetch(`${API_URL}/auth/logout`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });

      localStorage.removeItem('auth_check_block');
      localStorage.removeItem('demo_expired_alert_shown');
      
      navigate('/auth');
      
    } catch (error) {
      console.error('Logout error:', error);
      // Даже при ошибке очищаем и перенаправляем
      localStorage.removeItem('auth_check_block');
      localStorage.removeItem('demo_expired_alert_shown');
      navigate('/auth');
    }
  };

  return (
    <aside className={`dashboard-sidebar ${isOpen ? 'open' : ''}`}>
      <button 
        className="dashboard-sidebar-close" 
        onClick={onClose}
        aria-label="Close sidebar"
      >
        <i className="fas fa-times"></i>
      </button>

      <div className="sidebar-logo">PRIME PANEL</div>
      
      {/* 100% Рабочая локализация для всех 4-х языков */}
      <div className="sidebar-lang-container">
        {[
          { code: 'ru', icon: 'fa-globe-europe' },
          { code: 'en', icon: 'fa-globe-americas' },
          { code: 'zh', icon: 'fa-globe-asia' },
          { code: 'uk', icon: 'fa-globe-europe' }
        ].map((lang) => (
          <button 
            key={lang.code} 
            className={`lang-cyber-btn ${language === lang.code ? 'active' : ''}`}
            onClick={() => setLanguage(lang.code)}
          >
            <i className={`fas ${lang.icon}`}></i> {lang.code.toUpperCase()}
          </button>
        ))}
      </div>

      <nav className="sidebar-menu">
        <button className={`sidebar-item ${activeTab === 'key' ? 'active' : ''}`} onClick={() => handleTabClick('key')}>
          <i className="fas fa-id-card"></i> {t('dashboard.license')}
        </button>
        
        <button className={`sidebar-item ${activeTab === 'modules' ? 'active' : ''}`} onClick={() => handleTabClick('modules')}>
          <i className="fas fa-layer-group"></i> {t('dashboard.shop')}
        </button>
        
        <button className={`sidebar-item ${activeTab === 'news' ? 'active' : ''}`} onClick={() => handleTabClick('news')}>
          <i className="fas fa-scroll"></i> {t('dashboard.changelog')}
        </button>

        <button className={`sidebar-item ${activeTab === 'referral' ? 'active' : ''}`} onClick={() => handleTabClick('referral')}>
          <i className="fas fa-users"></i> {t('dashboard.referral')}
        </button>

        <button className={`sidebar-item ${activeTab === 'faq' ? 'active' : ''}`} onClick={() => handleTabClick('faq')}>
          <i className="fas fa-question-circle"></i> {t('dashboard.faq')}
        </button>

        <button className="sidebar-item download-btn" onClick={handleDownload}>
          <i className="fas fa-download"></i> {t('dashboard.download')}
        </button>

        <button className="sidebar-item logout-btn" onClick={handleLogout}>
          <i className="fas fa-power-off"></i> {t('nav.logout')}
        </button>
      </nav>
    </aside>
  );
};